import React, { Component } from "react";
import classNames from "classnames";


function renderMessages(messages, styleClass, testLocatorClass) {
    return messages.map((message, index) => {
        return <div className={classNames(styleClass, testLocatorClass)} key={index}>
            {message}
        </div>
    });
}

export default class MessageRenderer extends Component {
    render() {
        return (
            <div className="message" style={{
                position: this.props.position
                }}>
                { renderMessages(this.props.success, "message--success", "x-success-msg") }
                { renderMessages(this.props.errors, "message--error", "x-error-msg") }
                { renderMessages(this.props.warnings, "message--warning", "x-warning-msg") }
            </div>
        );
    }
}

MessageRenderer.propTypes = {
    success: React.PropTypes.array,
    errors: React.PropTypes.array,
    warnings: React.PropTypes.array
};

MessageRenderer.defaultProps = {
    success: [],
    errors: [],
    warnings: []
};




/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/MessageRenderer.js
 **/